import React from 'react';
import { Dialog, DialogTitle } from '@mui/material';

import { LocalizationContext } from '@cvt/contexts';

import { useSupportContact } from '../hooks/useSupportContact';
import { SupportContactForm, SupportContactFormValues } from '../partials/SupportContactForm';


type Props = {
  open: boolean;
  onClose: () => void;
};

export const SupportContactDialog: React.FC<Props> = ({ open, onClose }) => {

  const { dictionary } = React.useContext(LocalizationContext);
  const { sendSupportContact } = useSupportContact();

  const onSubmit = async (data: SupportContactFormValues) => {
    await sendSupportContact(data);
    onClose();
  };

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={onClose}
      slotProps={{ paper: { sx: { borderRadius: 0, boxShadow: 'none' } } }}
    >
      <DialogTitle typography="h2" sx={{ textAlign: 'center' }}>
        {dictionary.users.supportContact.dialog.title}
      </DialogTitle>
      <SupportContactForm onSubmitRequest={onSubmit} onCancel={onClose} />
    </Dialog>
  );
};
